// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Restaumatic_RouteAsURL from "../Restaumatic.RouteAsURL/index.js";
import * as Unscramble from "../Unscramble/index.js";
var AccountId = function (x) {
    return x;
};
var toFillFormTypeAccountId = Restaumatic_Form_TestHelpers.toFillFormTypeInt;
var showAccountId = Data_Show.showInt;
var ordAccountId = Data_Ord.ordInt;
var newtypeAccountId_ = {
    Coercible0: function () {
        return undefined;
    }
};
var eqAccountId = Data_Eq.eqInt;
var encodeAccountId = Foreign_Generic_Class.intEncode;
var decodeAccountId = Foreign_Generic_Class.intDecode;
var decodeAccountId1 = Unscramble.decodeInt1;
var asParamAccountId = Restaumatic_RouteAsURL.asParamInt;
export {
    AccountId,
    toFillFormTypeAccountId,
    asParamAccountId,
    decodeAccountId1,
    decodeAccountId,
    encodeAccountId,
    ordAccountId,
    eqAccountId,
    showAccountId,
    newtypeAccountId_
};
